import { useStyletron, P1, Button } from '@olxeu-jobs/ui';
import { FormattedMessage } from '~i18n';
import { FallOfTheIceCream } from '~ui/illustrations';
import type { GenericErrorBoundaryFallbackProps } from './types';

export const Fallback = ({
  hideResetButton,
  resetErrorBoundary,
}: GenericErrorBoundaryFallbackProps) => {
  const [css, theme] = useStyletron();

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      })}
    >
      <FallOfTheIceCream
        className={css({ width: '33%', maxWidth: '200px', minWidth: '100px', height: 'auto' })}
      />
      <P1
        $style={{
          marginTop: 0,
          marginBottom: 0,
          fontWeight: theme.fontWeights.medium,
          color: theme.colors['text-brand-primary'],
        }}
      >
        <FormattedMessage id="comp.error.generic.title" defaultMessage="Something went wrong" />
      </P1>
      {!hideResetButton && (
        <Button kind="tertiary" onClick={resetErrorBoundary}>
          <FormattedMessage id="comp.error.generic.refresh" defaultMessage="Refresh" />
        </Button>
      )}
    </div>
  );
};
